import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars

const {
  any,
  arrayOf,
  bool,
  number,
  object, // eslint-disable-line no-unused-vars
  objectOf,
  oneOfType,
  shape,
  string
} = PropTypes;

export const params = objectOf(
  oneOfType([
    string,
    bool,
    shape({
      default: oneOfType([bool, number, string]),
      description: oneOfType([string, arrayOf(string)]),
      displayName: string,
      example: string,
      paramName: string,
      required: oneOfType([bool, string]),
      type: oneOfType([string, arrayOf(string)]),
      value: any
    })
  ])
);

export default shape({
  appName: string,
  appID: string,
  displayName: string,
  description: string,
  configuredWithUserDefinedFields: bool,
  authAppIDs: arrayOf(string),
  authRequired: bool,
  params
});



// WEBPACK FOOTER //
// ./js/types/api/app.js